/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './date-formatter.stache';
import dayjs from 'dayjs';

Component.extend({
    tag: 'date-formatter',
    template: template,
    viewModel: {
        date: '',
        format: '',
        define: {
            formatted: {
                get: function() {
                    return dayjs(this.attr('date')).format(this.attr('format'));
                },
            },
        },
    },
    helpers: {},
    events: {},
});
